import { render, staticRenderFns } from "./DevicesSideviewInfoTab.vue?vue&type=template&id=09123882&scoped=true&class=fill-height"
import script from "./DevicesSideviewInfoTab.vue?vue&type=script&lang=ts"
export * from "./DevicesSideviewInfoTab.vue?vue&type=script&lang=ts"
import style0 from "./DevicesSideviewInfoTab.vue?vue&type=style&index=0&id=09123882&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09123882",
  null
  
)

export default component.exports